// Types

import { FeatureFlags } from '@/hooks/useFeatureFlags';

export const ADD_FEATURE_FLAGS = 'misc/ADD_FEATURE_FLAGS';

interface AddFeatureFlagsAction {
  type: typeof ADD_FEATURE_FLAGS;
  payload: FeatureFlags;
}

type InitActionTypes = AddFeatureFlagsAction;

// initial state
//
export interface FeatureFlagsState {
  data: FeatureFlags;
}

const initialState: FeatureFlagsState = {
  data: {},
};

// Reducer
// eslint-disable-next-line default-param-last
export default (state: FeatureFlagsState = initialState, action: InitActionTypes): FeatureFlagsState => {
  switch (action.type) {
    case ADD_FEATURE_FLAGS:
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
};

// Actions

export const addFeatureFlags = (payload: FeatureFlags) => ({
  type: ADD_FEATURE_FLAGS,
  payload,
});
